import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

interface MyDatePickerProps {
  value: string | null; // yyyy-mm-dd format
  onChange: (dateString: string | null) => void;
  placeholder?: string;
}

export default function DateConrol({
  value,
  onChange,
  placeholder = "Select a date",
}: MyDatePickerProps) {
  const datepickerRef = useRef<any>(null);

  // Parse prop string -> Date
  const parsedDate = value ? new Date(value) : null;

  // Format Date -> yyyy-mm-dd string
  const formatDateToString = (date: Date | null) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="input-group">
      <div
        style={{
          flex: "1 1 auto",
          width: "1%",
        }}
      >
        <DatePicker
          ref={datepickerRef}
          selected={parsedDate}
          onChange={(date) => onChange(formatDateToString(date))}
          dateFormat="MM/dd/yyyy" // Display format
          wrapperClassName="w-100"
          className="form-control"
          placeholderText={placeholder}
          popperPlacement="bottom-end"
        />
      </div>
      <span
        className="input-group-text"
        style={{ cursor: "pointer" }}
        onClick={() => datepickerRef.current?.setFocus()}
      >
        <FiCalendar />
      </span>
    </div>
  );
}
